<template>
    <Layout>
        <div class="home-page home">
            <div class="page-content" v-loading.fullscreen.lock="loading" element-loading-text="转链中"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.45)">

                <!-- 页面头部 -->
                <div class="page-header">
                    <h2>批量转链</h2>
                    <p>快速批量转换各平台商品链接，支持淘宝、京东、拼多多等主流电商平台</p>
                </div>

                <!-- 操作步骤 -->
                <el-card class="card-container steps-container" shadow="never" v-if="!list.length && !actList.length">
                    <el-steps :active="4" finish-status="success" align-center>
                        <el-step title="复制商品链接或口令" icon="el-icon-copy-document"></el-step>
                        <el-step title="粘贴到输入框中" icon="el-icon-document"></el-step>
                        <el-step title="系统自动识别并转链" icon="el-icon-refresh"></el-step>
                        <el-step title="点击复制分享给好友" icon="el-icon-share"></el-step>
                    </el-steps>
                </el-card>
                <!-- 转链类型 -->

                <template v-if="config && config.domain_one_click">
                    <div class="tab-section">
                        <el-tabs v-model="pageType" @tab-click="handleTabClick" class="custom-tabs">
                            <el-tab-pane v-for="(item, index) in pageList" :key="item.value" :label="item.label"
                                :name="item.value"></el-tab-pane>
                        </el-tabs>
                    </div>
                </template>
                <template v-if="pageType == 1">
                    <!-- 筛选区域 -->
                    <el-card class="card-container" shadow="never"
                        v-if="transText && (convert.convert_type == 1 || (convert.convert_type == 4 && config.webtool_pdd_status == 1))">
                        <div class="filter-section">
                            <!-- 商品类型 -->
                            <div class="filter-group">
                                <label class="filter-label">商品类型
                                    <el-tooltip class="item" effect="dark">
                                        <div slot="content">
                                            特殊商品类型可切换到对应的商品类型重新转换链接，如"百亿补贴"。
                                        </div>
                                        <i class="el-icon-question font18"></i>
                                    </el-tooltip>：
                                </label>
                                <template v-if="convert.convert_type == 1">
                                    <el-radio-group v-model="currentCheck" @change="changeCheck">
                                        <el-radio-button v-for="rank in checkTypeList" :key="rank.value"
                                            :label="rank.value">{{
                                                rank.label }}</el-radio-button>
                                    </el-radio-group>
                                </template>
                                <template v-else>
                                    <el-radio-group v-model="currentCheck" @change="changeCheck">
                                        <el-radio-button v-for="item in pddCheckType" :key="item.value"
                                            :label="item.value">{{
                                                item.label }}</el-radio-button>
                                    </el-radio-group>
                                </template>

                            </div>
                        </div>
                    </el-card>
                </template>

                <el-row :gutter="20" class="main">
                    <el-col :span="list.length || actList.length ? 14 : 24">
                        <el-card shadow="never" class="m-b-20 main-card">
                            <div slot="header" class="card-head">
                                <div class="flex justify-between">
                                    <div class="flex align-center">
                                        <div class="link m-r-10" :class="'link' + isSuccess">
                                            <i class="el-icon-link bold"></i>
                                        </div>
                                        <div class="bold">{{ isSuccess == 1 ? '转链成功' : isSuccess == 2 ? '转链失败' : '待转链'
                                            }}
                                        </div>
                                    </div>
                                    <div class="text-red pointer font14" @click="handleClear" v-if="transText">
                                        清空
                                        <i class="el-icon-delete"></i>
                                    </div>
                                    <!-- <img src="https://img.huajuanyun.com/utools/2024/1016/1729069291489.png" v-else
                                        class="img-tip" /> -->
                                </div>

                            </div>
                            <div class="cpm-text" v-if="pageType == 1 && isCpm">
                                解锁抖音限时高佣商品！<br /><span>口令仅1️⃣小时内有效</span><span>仅支持1️⃣个抖音账号使用</span><span>🚫不支持二次转链</span><span>分享社群可选择中间页短链👇</span>
                            </div>

                            <div class="flex justify-center card-body" @click="setFocus">
                                <div class="place-box color9" v-if="showText">
                                    <div>
                                        <img src="https://img.huajuanyun.com/utools/2024/1016/1729069291489.png"
                                            width="60%" class="m-b-10" />
                                    </div>
                                    <div>
                                        请在此处粘贴您需要转换的(文案+淘口令)/(文案+链接)/商品URL；<br />
                                        电商平台支持淘宝、京东、拼多多、唯品会、抖音、快手、苏宁易购，<br />
                                        本地生活支持美团、饿了么、滴滴打车，支持单平台多个口令/链接批量转换
                                    </div>
                                </div>
                                <div class="text-box" v-if="!showText">
                                    <el-input type="textarea" ref="textarea" :autosize="{ minRows: 10, maxRows: 10 }"
                                        v-model="transText" :autofocus="true" @blur="handleBlur"
                                        @paste.native="getPaste"></el-input>
                                    <div class="result" v-if="isSuccess != 0">
                                        转链成功 <span class="text-green bold">{{ convert.success }}</span> 条，
                                        失败 <span class="text-red bold">{{ convert.fail }}</span> 条
                                    </div>
                                </div>
                            </div>
                            <!-- 转链类型 -->
                            <div class="type-list m-t-20"
                                v-if="pageType == 1 && transText && list.length > 0 && (convert.convert_type == 1 || convert.convert_type == 25 || convert.convert_type == 4 || convert.convert_type == 3 || convert.convert_type == 9)">
                                <template
                                    v-if="convert.convert_type == 1 &&isSuccess == 1 && currentCheck == 0">
                                    <div class="flex align-center m-b-10">

                                        <el-switch v-model="redPack" @change="getMyUrl">
                                        </el-switch>
                                        <span class="m-l-5 font14">超级红包</span>
                                        <el-tooltip class="item" effect="dark">
                                            <div slot="content">
                                                开启后将生成带超级红包领取的商品推广口令或链接
                                            </div>
                                            <i class="el-icon-question font18 m-l-5"></i>
                                        </el-tooltip>
                                    </div>
                                </template>
                                <div class="label bold m-b-10">选择转链方式</div>
                                <el-radio-group v-model="tbUrlType" @change="getMyUrl" v-if="convert.convert_type == 1">
                                    <el-radio :label="0">淘口令</el-radio>
                                    <el-radio :label="1">淘宝短链</el-radio>
                                    <el-radio :label="2" v-if="list && list.length">中间页短链</el-radio>
                                </el-radio-group>
                                <el-radio-group v-model="dyUrlType" @change="getMyUrl"
                                    v-if="convert.convert_type == 25 && isCpm && list && list.length">
                                    <el-radio :label="1">中间页短链<span
                                            class="m-l-10 text-red bold">适用于分享给多个好友使用</span></el-radio>
                                </el-radio-group>
                                <el-radio-group v-model="pddurlType" @change="getMyUrl"
                                    v-if="convert.convert_type == 4">
                                    <el-radio :label="2">普通链接</el-radio>
                                    <el-radio :label="1">小程序短链接</el-radio>
                                </el-radio-group>
                                <el-radio-group v-model="jdUrlType" @change="getMyUrl" v-if="convert.convert_type == 3">
                                    <el-radio :label="2">H5短链接</el-radio>
                                    <el-radio :label="3">京口令</el-radio>
                                    <el-radio :label="1">小程序短链接</el-radio>
                                </el-radio-group>
                                <el-radio-group v-model="vipUrlType" @change="getMyUrl" v-if="convert.convert_type == 9">
                                    <el-radio :label="2">H5短链接</el-radio>
                                    <el-radio :label="1">小程序短链接</el-radio>
                                    <el-radio :label="3">唯口令</el-radio>
                                    
                                </el-radio-group>
                            </div>
                        </el-card>
                        <div class="flex justify-center btn-group">
                            <template v-if="isSuccess != 0">
                                <el-button @click="getMyUrl" :type="isSuccess == 1 ? 'default' : 'primary'"
                                    class="btn m-r-20" style="width: 50%;">重新转换链接</el-button>
                                <el-button @click="handleCopy" :type="isSuccess == 1 ? 'primary' : null"
                                    :disabled="isSuccess == 2" class="btn" style="width: 50%;">一键复制</el-button>
                            </template>
                            <el-button type="primary" v-else :disabled="!transText" @click="getMyUrl"
                                style="width: 100%">{{ pageType ==
                                    1
                                    ? '转换成我的推广链接' : '转换为短链接' }}</el-button>
                        </div>
                    </el-col>
                    <el-col :span="10" v-if="list.length || actList.length">
                        <el-card shadow="never" :body-style="{ padding: '0' }" class="goods-card">
                            <div slot="header" class="card-head">
                                <div class="flex align-center">
                                    <div class="link m-r-10">
                                        <i class="el-icon-goods bold"></i>
                                    </div>
                                    <div class="bold">{{ list.length ? '识别到以下商品并转链' : actList.length ? '识别到以下活动并转链' :
                                        '操作步骤' }}</div>
                                </div>
                            </div>
                            <div class="card-body result-body">
                                <template v-if="list.length">
                                    <div class="flex list-item" v-for="item in list" :key="item.id">
                                        <div class="item-image pointer" @click="handleGoodsClick(item)">
                                            <img class="img-info" :src="item.image" alt />
                                            <div class="img-info-live" v-if="item.is_living == true">
                                                <img src="https://img.huajuanyun.com/utools/2025/73/1751512178088.gif"
                                                    width="18" height="18">
                                                直播中
                                            </div>
                                            <div class="cpm-tag" v-if="item.is_dy_cpm">
                                                限时高佣
                                            </div>
                                        </div>
                                        <div class="item-content">
                                            <div class="content-top pointer" @click="handleGoodsClick(item)">
                                                <div class="title text-line-2 font16">
                                                    <img class="icon-logo"
                                                        :src="`https://h5.dhcc.wang/images/goods_detail/sharepage_type_${item.is_living == true ? 'tblive' : item.type}.png`"
                                                        alt />
                                                    {{ item.sub_title || item.title }}
                                                </div>
                                                <div class="coupon">
                                                    <div class="commision font12">
                                                        <span class="btn first customFont" v-if="item.fan_price">
                                                            分享赚￥{{ item.fan_price }}</span>
                                                    </div>
                                                    <div class="coupon-lf font12" v-if="item.coupon_price">
                                                        <span class="cou customFont"><span class="font12">券</span>￥{{
                                                            item.coupon_price }}</span>
                                                    </div>
                                                    <div class="commision font12" v-if="config.goods_tkrates_status == 1 && item.fan_price_tkrates">
                                                        <span class="btn rate customFont">佣金比例{{ item.fan_price_tkrates }}%</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="content-bottom">
                                                <div class="price">
                                                    <span class="font14" style="color: #D0021B">券后￥</span>
                                                    <span class="font20 bold customFont" style="color: #D0021B">{{
                                                        item.final_price
                                                        }}</span>
                                                    <span class="font14 text-grey text-del customFont">￥{{
                                                        item.origin_price
                                                        }}</span>
                                                </div>
                                                <div class="shop flex justify-between text-grey font14">
                                                    <div class="flex align-center" v-if="item.shop_title">
                                                        <i class="iconfont icon-shop"></i>
                                                        <span style="margin-left: 3px;">{{ item.shop_title }}</span>
                                                    </div>
                                                    <div class="flex align-center pointer" v-if="item.type == 4"
                                                        @click="copyGoodsId(item.origin_id)">
                                                        商品Id：{{ extractNumber(item.origin_id) }}
                                                    </div>
                                                    <div class="flex align-center pointer"
                                                        v-if="item.type == 4 && item.zs_duo_id"
                                                        @click="copyGoodsId(item.zs_duo_id)">
                                                        团长Id：{{ item.zs_duo_id }}
                                                    </div>
                                                    <span class="txt text-grey">月销{{ (item.month_sales ||
                                                        item.sales_num)
                                                        | filterSales }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-if="actList.length">
                                    <div class="flex list-item pointer" v-for="(item, index) in actList" :key="index">
                                        <div class="item-image act-img">
                                            <img :src="item.main_img" alt="" class="img-info">
                                        </div>
                                        <div class="item-content act-content">
                                            <div class="content-top">
                                                <div class="title text-line-1 font16 m-b-5">
                                                    <img class="icon-logo"
                                                        :src="`https://h5.dhcc.wang/images/goods_detail/sharepage_type_${item.is_pg == 1 ? 'jx' : item.type}.png`"
                                                        alt />
                                                    {{ item.title }}
                                                </div>
                                                <div class="font14 text-red m-b-10">{{ item.description }}</div>
                                                <div class="text-grey">活动时间：{{ formatTime(item.starttime * 1000,
                                                    'Y-M-D') }} ~ {{ formatTime(item.endtime * 1000, 'Y-M-D') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </div>
        <GoodsDetailHandler ref="goodsHandler" @loading-change="handleLoadingChange" @success="handleGoodsSuccess"
            @error="handleGoodsError" />
    </Layout>
</template>

<script>
import Layout from '@/components/Layout/index'
import GoodsDetailHandler from '@/components/GoodsDetailHandler'
import { transformUrl, checkBeian } from '@/api/public'
import { formatTime } from '@/utils/timeTransfer'
const PLATFORM_TYPE = {
    1: '淘宝',
    2: '淘宝',
    3: '京东',
    4: '拼多多',
    9: '唯品会'
}
export default {
    components: {
        Layout,
        GoodsDetailHandler
    },
    data() {
        return {
            showText: true,
            convert: {},
            currentCheck: 0,
            pageType: '1',
            pageList: [
                {
                    label: '智能转链',
                    value: '1'
                },
                {
                    label: '生成短链',
                    value: '2'
                }
            ],
            checkTypeList: [{
                label: '日常商品',
                value: 0
            }, {
                label: '百亿补贴',
                value: 1
            },
            // {
            //     label: '签到红包',
            //     value: 2
            // },
            {
                label: '淘宝直播',
                value: 5
            }
            ],
            pddCheckType: [
                {
                    label: '普通商品',
                    value: 0
                }, {
                    label: '超红二合一',
                    value: 4
                }
            ],
            tbUrlType: 0,
            dyUrlType:0,
            pddurlType: 2,
            jdUrlType: 2,
            vipUrlType:2,
            transText: '',
            isSuccess: 0, // 0 未转链 1  转链成功 2 转链失败
            list: [],
            loading: false,
            rawData: '', // 原始数据
            isDisable: false,
            actList: [],
            isCpm: false,
            redPack: false
        }
    },
    computed: {
        config() {
            return this.$store.getters.config
        }
    },
    methods: {
        formatTime,
        extractNumber(originId) {
            if (!originId) return null;
            const match = originId.toString().match(/(\d+)$/);
            return match ? match[1] : null;
        },
        //输入框粘贴事件
        getPaste(event) {
            if (this.loading) {
                event.preventDefault()
                return
            }
            setTimeout(() => {
                this.rawData = this.transText.trim()
                if (this.rawData.trim()) {
                    this.getMyUrl()
                }
            }, 0)
        },

        changeCheck(item) {
            // this.currentCheck = item.value
            this.getMyUrl()
        },
        // 处理商品类型切换
        handleCheckChange(value) {
            this.currentCheck = value
            this.getMyUrl()
        },
        // 显示文本域，获取焦点
        setFocus() {
            this.showText = false
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.textarea.focus()
                }, 0)
            })
        },
        // 清空
        handleClear() {
            this.transText = ''
            this.showText = true
            this.isSuccess = 0
            this.currentCheck = 0
            this.tbUrlType = 0
            this.dyUrlType = 0
            this.pddurlType = 2
            this.jdUrlType = 2
            this.vipUrlType = 2
            this.isCpm = false
            this.list = []
            this.convert = {}
            this.redPack = false
        },
        handleBlur() {
            if (!this.transText.trim()) {
                this.showText = true
            }
        },
        handleCopy() {
            if (!this.transText.trim()) return this.$message.error('请先进行转换')
            this.$copyText(this.transText).then(() => {
                this.$message.success('复制成功')
                this.$refs.textarea.select()
            }, () => {
                this.$message.error('复制失败，请自行选中复制')
            })
        },
        copyGoodsId(goodsId) {
            this.$copyText(this.extractNumber(goodsId)).then(() => {
                this.$message.success('复制成功')
            }, () => {
                this.$message.error('复制失败，请自行选中复制')
            })
        },
        getMyUrl() {
            if (!this.transText.trim()) return
            if (!this.isSuccess) { // 待转链，转链时记录原始数据
                this.rawData = this.transText
            }
            if (this.transText && this.convert.convert_type == 1) {
                if (this.currentCheck != 0) {
                    this.redPack = false
                }
            } else {
                this.redPack = false
            }
            let params = {
                content: this.rawData,
                check_beian: 1
            }
            if (this.pageType == 1) {
                params.special_goods = this.redPack?6:this.currentCheck
                // params.special_goods =  this.currentCheck
                params.tb_url_type = this.tbUrlType
                params.dy_url_type = this.dyUrlType
                params.pdd_url_type = this.pddurlType
                params.jd_url_type = this.jdUrlType
                params.vip_url_type = this.vipUrlType

            } else {
                params.gen_short_url = 1
            }
            this.loading = true
            transformUrl(params).then(async res => {
                this.loading = false
                if (res.code == 1) {
                    this.isSuccess = 1
                    this.convert = res.data
                    this.transText = res.data.content
                    this.$message.success(res.msg)
                    this.list = res.data.goods_list
                    this.actList = res.data.act_list || []
                    if (this.list && this.list.length > 0) {
                        this.isCpm = this.list[0].is_dy_cpm
                    } else {
                        this.isCpm = false
                    }

                } else {
                    this.isSuccess = 2
                    this.convert = {
                        success: 0,
                        fail: 1
                    }
                    const { convert_type } = res.data
                    let url = ''
                    if (res.data.convert_type === 1|| res.data.convert_type === 4|| res.data.convert_type === 9) { // 唯品会
                       const ret = await this.isBeian(res.data.convert_type)
                       if(ret.need_beian==1){
                        if(res.data.convert_type==1){
                            url = ret.beian_url
                        }else if(res.data.convert_type == 4){
                            url = ret.beian_urls.short_url
                        }else{
                            url = ret.beian_urls.shortUrl
                        }

                       }
                    }
                    if (url) {
                        this.$confirm(`应${PLATFORM_TYPE[convert_type]}官方要求，获得返佣前请先进行授权备案！`, '备案授权提醒')
                            .then(_ => {
                                window.open(url, '_blank')
                            }).catch(_ => { })
                    } 
                   
                }
            }).catch(() => {
                this.loading = false
            })
        },
        isBeian(type=1){
            return new Promise((resolve, reject) => {
                checkBeian({ union_type : type}).then(res=>{
                    resolve(res.data)
                })
                .catch(() => { 
                    reject('检查备案状态失败')
                })
            })
        },
        checkChange(e) {
            if (e == 6) {
                this.currentCheck = 0
            }
            this.getMyUrl()
        },
        // 处理商品点击
        handleGoodsClick(item) {
            if (this.isDisable) return
            console.log('首页商品数据:', item)
            this.$refs.goodsHandler.handleGoodsClick(item)
        },

        // 处理加载状态变化
        handleLoadingChange(loading) {
            this.loading = loading
            this.isDisable = loading
        },

        // 处理商品详情成功
        handleGoodsSuccess(data) {
            console.log('商品详情处理成功:', data)
        },

        // 处理商品详情错误
        handleGoodsError(error) {
            console.log('商品详情处理错误:', error)
        },
        handleTabClick(e) {
            this.pageType = e.name
            this.getMyUrl()
        }
    },
    filters: {
        filterSales(val) {
            let num = Number(val || 0)
            if (isNaN(num)) return val || 0
            return num > 9999 ? (Math.floor(num / 10000) + '万') : num
        }
    },
    watch: {
        transText() {
            if (!this.transText) {
                this.handleClear()
                this.rawData = ''
            } else {
                this.showText = false
            }
        },
        // 监听convert_type, 有变化tab重置
        'convert.convert_type'() {
            this.currentCheck = 0
            this.tbUrlType = 0
            this.dyUrlType = 0
        }
    },

}
</script>

<style scoped lang="scss">
.home-page {
    padding: 20px;
    min-height: calc(100vh - 60px);
}

.page-content {
    width: 100%;
    margin: 0 auto;
}

.page-header {
    margin: 24px 0;

    h2 {
        margin: 0 0 8px 0;
        font-size: 24px;
        font-weight: 600;
        color: #303133;
    }

    p {
        margin: 0;
        color: #909399;
        font-size: 14px;
    }
}

.card-container {
    margin-bottom: 20px;
    border-radius: 8px;
    border: 1px solid #ebeef5;

    ::v-deep .el-card__body {
        padding: 20px;
    }
}

.check-list {
    &-item {
        position: relative;
        margin-right: 30px;

        &.check-active {
            color: #333;

            &:after {
                content: '';
                position: absolute;
                bottom: -5px;
                left: 50%;
                width: 30px;
                height: 4px;
                margin-left: -15px;
                border-radius: 8px;
                background: linear-gradient(-90deg, $primary-color, generate-transparent-background(0.6));
            }
        }
    }
}

::v-deep .el-card {
    border-radius: 10px;
}

.home {
    width: 100%;
    max-width: 1680px;
    margin: 0 auto;

    .main {
        padding: 0;



        ::v-deep .el-card__header {
            padding: 0;
        }

        .card-head {
            padding: 20px;
            font-size: 18px;
            background: #ffffff;

            .link {
                width: 20px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                border-radius: 50%;
                background: #e2e2e2;

                &.link1 {
                    background: #39b54a;
                    color: #fff;
                }

                &.link2 {
                    background: #e54d42;
                    color: #fff;
                }
            }

            .img-tip {
                height: 26px;
            }
        }

        .cpm-text {
            color: #ff4142;
            padding: 5px 15px 8px;
            font-size: 13px;
            margin: 0 10px;
            background-color: #fff0f0;
            border-radius: 5px;
            margin-bottom: 10px;
            font-weight: bold;

            span {
                margin: 1px;
                display: inline-block;
                background: #ff4142;
                padding: 0 5px;
                font-size: 12px;
                font-weight: normal;
                border-radius: 3px;
                color: #ffffff;
            }
        }

        .type-list {
            background: #f5f5f5;
            border-radius: 5px;
            padding: 10px 20px;
        }

        .card-body {
            height: 100%;
            min-height: 300px;

            &.result-body {
                max-height: 800px;
                overflow: auto;
            }

            .place-box {
                font-size: 16px;
                text-align: center;
                color: #909399;
                max-width: 600px;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                width: 80%;

                .empty-img {
                    width: 100px;
                }

                .place-text {
                    width: 400px;
                    margin: 20px auto;
                }
            }

            .text-box {
                position: relative;
                flex: 1;

                .result {
                    position: absolute;
                    bottom: 0;
                    padding: 10px 0 0;
                }
            }

            .list-item {
                margin: 10px;
                padding: 15px;

                /* background: red; */
                /* border-bottom: 1px solid #f5f5f5; */
                .icon-logo {
                    height: 16px;
                    margin-right: 3px;
                    position: relative;
                    top: 2px;
                }

                .item-image {
                    width: 120px;
                    height: 120px;
                    flex: 0 0 120px;
                    border-radius: 5px;
                    overflow: hidden;
                    position: relative;

                    .img-info-live {
                        position: absolute;
                        background-color: rgba(0, 0, 0, .5);
                        left: 5px;
                        top: 5px;
                        border-radius: 20px;
                        color: #fff;
                        font-size: 13px;
                        line-height: 20px;
                        height: 20px;
                        padding: 0 6px;
                        display: flex;
                        align-items: center;

                        img {
                            width: 18px;
                            margin-right: 3px;
                        }
                    }

                    .cpm-tag {
                        position: absolute;
                        background: linear-gradient(90deg, rgb(255, 65, 66), rgb(255, 75, 43));
                        color: #fff;
                        font-size: 11px;
                        line-height: 20px;
                        height: 20px;
                        padding: 0 6px;
                        display: flex;
                        align-items: center;
                        right: 5px;
                        top: 5px;
                        border-radius: 20px;
                    }

                    &.act-img {
                        width: 150px;
                        height: auto;
                    }

                    img {
                        width: 100%;
                        border-radius: 5px;
                    }
                }

                .item-content {
                    // height: 120px;
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    overflow: hidden;
                    padding: 0 5px 0 10px;

                    &.act-content {
                        height: auto;
                    }
                }

                .content {
                    &-top {
                        .title {
                            font-weight: 600;
                            margin-bottom: 6px;
                        }
                    }
                }

                &:hover {
                    background: #f5f5f5;
                    transition: .2s ease-in;
                    border-radius: 5px;
                }

                .price {
                    margin-bottom: 6px;
                }

                .coupon {
                    display: flex;
                    align-items: center;

                    &-lf {
                        .cou {
                            color: #fff;
                            background-image: -webkit-gradient(linear, right top, left top, from(#e62828), to(#ff5a3c));
                            background-image: -o-linear-gradient(right, #e62828 0, #ff5a3c 100%);
                            background-image: linear-gradient(-90deg, #e62828, #ff5a3c);
                            padding: 2px 10px;
                            border-radius: 2px;
                            position: relative;
                            font-size: 13px;
                            margin-right: 10px;

                            &::before,
                            &::after {
                                content: "";
                                width: 6px;
                                height: 6px;
                                background: #fff;
                                border-radius: 50%;
                                position: absolute;
                                top: 50%;
                                margin-top: -3px;
                            }

                            &::before {
                                left: 0;
                                margin-left: -3px;
                            }

                            &::after {
                                right: 0;
                                margin-right: -3px;
                            }
                        }

                        .txt {
                            margin: 0 5px 0 15px;
                        }
                    }
                }

                .text-del {
                    margin-left: 5px;
                    text-decoration: line-through;
                }

                .commision {
                    display: flex;
                    align-items: center;

                    .btn {
                        /* border:1px solid #b9831a; */
                        /* box-shadow:0 1px 5px 0 rgba(230,40,40,.3); */
                        color: #A26120;
                        padding: 2px 5px;
                        background: #FFE1A7;
                        margin-right: 10px;
                        border-radius: 3px;

                        &.first {
                            background: #ffdedf;
                            /* border:1px solid #df3033; */
                            /* box-shadow:0 1px 5px 0 rgba(230,40,40,.3); */
                            color: #df3033;
                        }
                    }
                }
            }

            .btn-group {
                .btn {
                    width: 200px !important;
                }
            }

            ::v-deep {
                .el-steps--vertical {
                    position: absolute;
                    top: 120px;
                    right: 180px;
                }

                .el-step__title.is-process {
                    font-weight: normal;
                    color: #555555;
                }

                .el-step.is-vertical .el-step__icon.is-icon {
                    color: #999999;
                    background: #fff;
                    border-radius: 100px;
                }

                .el-step.is-vertical .el-step__line {
                    width: 1px;
                    background-color: #f1f1f1;

                }

                .el-textarea__inner {
                    border: none;
                    font-size: 16px;
                    color: #333;
                    line-height: 24px;
                }
            }
        }

    }
}

.tab-section {
    margin-bottom: 20px;
    background: white;
    border-radius: 10px;
    border: 1px solid #ebeef5;
    padding: 0 20px;
}

.custom-tabs {
    ::v-deep {
        .el-tabs__header {
            margin: 0;
            border-bottom: 1px solid #e4e7ed;
        }

        .el-tabs__item {
            font-size: 18px;
            font-weight: 600;
            height: 60px;
            line-height: 60px;
            color: #606266;
            padding: 0 30px;
            position: relative;

            &.is-active {
                color: var(--main-bg-color);
                font-weight: 700;
                position: relative;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 30px;
                    height: 4px;
                    background-color: var(--main-bg-color);
                    border-radius: 2px;
                    z-index: 2;
                }
            }

            &:hover {
                color: var(--main-bg-color);
            }

            &:nth-child(2) {
                padding-left: 30px !important;
            }

            &:last-child {
                padding-right: 30px !important;
            }
        }

        .el-tabs__active-bar {
            display: none;
        }

        .el-tabs__nav-wrap {
            &::after {
                height: 1px;
            }
        }
    }


}

.filter-section {
    .filter-group {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        &:last-child {
            margin-bottom: 0;
        }

        .filter-label {
            font-weight: 500;
            margin-right: 15px;
            min-width: 80px;
            color: #606266;
        }

        ::v-deep {
            .el-radio-button__inner {
                border-radius: 6px;
                margin-right: 4px;
                border: 1px solid #dcdfe6;
            }

            .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                box-shadow: none;
            }
        }
    }
}
</style>
